import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { IStudiesAllStateParamsUnboxed } from '../state/ui/study-table-ui.model';
import { PagedDataDtoOfStudyDetailsDto } from '@core/services/api-client.generated';

export type StudiesTableScope = 'project' | 'stage';

export const studiesActions = createActionGroup({
  source: 'Studies',
  events: {
    'set filter activation': props<{ activated: boolean }>(),
    'fetch study list': props<IStudiesAllStateParamsUnboxed>(),
    // Fetch the list again with the parameters already in the store (reversible deletion S4a: a search was deleted).
    'refresh study list': emptyProps(),
    'navigate table': props<{ fromRow: number; pageSize: number }>(),
    'study list updated': props<PagedDataDtoOfStudyDetailsDto>(),
    // The fetch failed: the Library shows its in-page error state, and "Try again" dispatches refreshStudyList.
    'study list load failed': emptyProps(),
    // The Library filter bar's "Clear filters"; the filtered-empty state also clears the search term.
    'clear filters': props<{ includeSearchTerm: boolean }>(),
  },
});
